































import { OWebAccountRecovery } from "oweb";
import BaseComponent from "@/components/BaseComponent.vue";
import app from "@/app";
import { Component } from "vue-property-decorator";

@Component
export default class WUserAccountRecoveryOne extends BaseComponent {
	form = getForm();

	sendForm(event: any) {
		let form: HTMLFormElement = event.target,
			o = new OWebAccountRecovery(app);

		o.onError(function(response) {
			app.view.dialog(response);
		})
			.onNextStep(function(response) {
				app.router.browseTo("/me/recover/two", response.data);
			})
			.stepStart(form);
	}
}

const getForm = function() {
	return {
		fields: {
			phone: {
				field: "phone",
				attrs: {
					name: "phone",
					autofocus: "autofocus",
					autocomplete: "off"
				},
				label: { i18n: "OO_LANG_PHONE" }
			},
			submit: { field: "submit", i18n: "OO_LANG_VALIDATE_BTN" }
		}
	};
};
